import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ThreadAction } from '@stores/thread/action';
import type { TopicAction } from '@stores/topic/action';
import PC from './layout/pc';
import H5 from './layout/h5';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import type { BasePageState } from '../../types/base';
import { CommonAction } from '@stores/common/action';

interface RouteParams {
  id: string;
}
interface TopicThreadListProps extends BasePageProps, RouteComponentProps<RouteParams> {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    thread?: ThreadAction;
    topic?: TopicAction;
    common?: CommonAction;
}

interface TopicThreadListState extends BasePageState {
    idsArray: any
}
@inject('app', 'user', 'topic', 'common')
@observer
class TopicThreadList extends BasePage<TopicThreadListProps, TopicThreadListState> {
    topicId = '';   // 话题id
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
        idsArray: [],   // 筛选相关话题id下的帖子列表
    }
    async componentDidMount() {
       const { app, user, topic, common, match } = this.props;
       console.log('话题帖子列表页')
        this.topicId = match.params.id;
        if (match.params.id) {
            this.setState({
                idsArray: [match.params.id]
            }, () => {
                this.loadTopicData();
            })
        }
        
        super.componentDidMount();
    }

    componentDidUpdate(prevProps: any) {
        console.log('话题id改变了吗', this.props.match.params.id);
        // 监听路由参数变化，如果话题 ID 改变，重新加载数据
        if (prevProps.match.params.id !== this.props.match.params.id) {
            this.topicId = this.props.match.params.id;
            const { app, user, topic, common, match } = this.props;
            if (match.params.id) {
                this.setState({
                    idsArray: [match.params.id]
                }, () => {
                    this.loadTopicData();
                })
            }
            // this.loadTopicData();
        }
    }

    // 加载话题数据
    loadTopicData = async () => {
        const { app, user, topic } = this.props;
        let { idsArray } = this.state;
        if(!topic) return;
        // 获取话题帖子列表
        let params: any = {
            "page[number]": 1,
            "page[size]": 20
        }
        // 将多个 filter[ids][] 合并为一个 filter[ids] 数组
        if (idsArray && idsArray.length > 0) {
            // 确保所有 ID 都是字符串格式
            params['filter[ids]'] = idsArray.map(id => String(id));
        }
        await topic.getTopicThreadList(params).then((res: any) => {
            console.log('话题帖子列表:', res);
        }).catch(error => {
            console.error('获取话题帖子列表失败:', error);
        });
    }


    render() {
        console.log('话题帖子列表页');
        const { app } = this.props;
        const platform = app?.platform || 'h5';
        // 如果平台信息还未初始化，显示加载状态
        if (!app?.platform) {
            return (
                <div className={styles.loading} style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh'
                }}>
                    <div>加载中...</div>
                </div>
            );
        } else {
           return (<div className={platform === 'pc' ? styles.pcWrap : styles.h5Wrap}>
                {platform === 'pc' ? (<PC
                        handleSetState={(data, rep) => this.setState({ ...data })}
                        {...this.props}
                    ></PC>
                ) : (
                    <H5
                        handleSetState={(data, rep) => this.setState({ ...data })}
                        {...this.props}
                    ></H5>
                )}
            </div>)
        }
        
    }
}

export default withRouter(TopicThreadList);